// Mock data for Shine Core Advisory LLC Landing Page

export const heroData = {
  headline: "Compliance. Clarity. Control.",
  subheadline: "Structured Accounting & Tax Advisory for Growing UAE Businesses.",
  ctaPrimary: "Book Free Consultation",
  ctaSecondary: "Get Pricing",
  backgroundImage: "https://images.unsplash.com/photo-1726533765275-a69cfd7f9897"
};

export const founderData = {
  name: "Paul Devakumar Rajkumar",
  title: "Founder & Managing Director",
  photo: "https://customer-assets.emergentagent.com/job_shine-accounting/artifacts/dru3wwo0_Picture_Emergent_%20Managing%20Director%20note.jpeg",
  bio: "The founder is a UAE-based Finance and Accounting Expert with over 15 years of experience in the finance and accounting industry. He specializes in full-cycle accounting, VAT compliance, corporate tax advisory, and financial reporting for Free Zone and Mainland businesses. He has worked extensively with PRO service companies and SMEs, managing bookkeeping, statutory compliance, payroll, reconciliations, audit coordination, and tax advisory services.",
  expertise: "With a strong background in IFRS, UAE VAT regulations, and the Corporate Tax framework, the founder leads Shine Core Advisory LLC with a compliance-first, accuracy-driven approach. His expertise spans Free Zone Qualifying Person (QFZP) assessments, VAT advisory, financial structuring, and building audit-ready financial systems for startups and growing businesses.",
  credentials: "The founder holds a Bachelor's degree in Finance and Accounting and B.Com, and is currently pursuing the US CMA qualification to strengthen strategic financial leadership capabilities. The firm is further supported by strong partnerships with UAE Chartered Accountants, FTA-registered Tax Agents, and E-Invoicing Accredited Service Providers (ASP), ensuring clients receive comprehensive and regulatory-compliant financial solutions."
};

export const servicesData = [
  {
    id: 1,
    title: "Accounting & Bookkeeping",
    description: "Professional financial record-keeping with real-time visibility into your business performance.",
    features: [
      "Monthly reporting",
      "Bank reconciliations",
      "IFRS-aligned financials"
    ],
    image: "https://images.unsplash.com/photo-1762427354051-a9bdb181ae3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBhY2NvdW50aW5nfGVufDB8fHx8MTc3MTMwMDIzNHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "VAT & Corporate Tax",
    description: "Full-spectrum tax compliance and advisory to keep your business aligned with UAE regulations.",
    features: [
      "VAT registration & filing",
      "Corporate Tax advisory",
      "FTA compliance"
    ],
    image: "https://images.unsplash.com/photo-1753955900083-b62ee8d97805?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBhY2NvdW50aW5nfGVufDB8fHx8MTc3MTMwMDIzNHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "ESR & UBO Compliance",
    description: "Navigate Economic Substance Regulations and UBO requirements with expert guidance.",
    features: [
      "ESR notification & reporting",
      "UBO register preparation",
      "Regulatory documentation"
    ],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzcxMzAwMjM5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Virtual CFO Services",
    description: "Strategic financial leadership and insights without the full-time CFO cost.",
    features: [
      "Cash flow forecasting",
      "Financial dashboards",
      "Strategic advisory"
    ],
    image: "https://images.unsplash.com/photo-1748609160056-7b95f30041f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxmaW5hbmNpYWwlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzcxMzAwMjM5fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const whyChooseUsData = [
  {
    id: 1,
    title: "Audit-Ready Systems",
    description: "Clean documentation, structured reconciliations, and reporting discipline aligned with IFRS and UAE standards.",
    icon: "shield-check"
  },
  {
    id: 2,
    title: "UAE Regulatory Expertise",
    description: "Deep knowledge of VAT, Corporate Tax, ESR, and UBO requirements specific to UAE business operations.",
    icon: "book-open"
  },
  {
    id: 3,
    title: "SME & Free Zone Specialists",
    description: "Purpose-built solutions for Mainland and Free Zone structures with scalable systems for growth.",
    icon: "building-2"
  },
  {
    id: 4,
    title: "Technology-Driven Reporting",
    description: "Modern accounting software, automation, and real-time dashboards for data-driven decision making.",
    icon: "line-chart"
  }
];

export const howItWorksData = [
  {
    step: 1,
    title: "Consultation & Assessment",
    description: "We analyze your current setup, understand your business structure, and identify compliance gaps."
  },
  {
    step: 2,
    title: "Setup & System Implementation",
    description: "We implement accounting systems, establish processes, and configure financial reporting frameworks."
  },
  {
    step: 3,
    title: "Ongoing Compliance & Reporting",
    description: "Continuous bookkeeping, tax filing, regulatory compliance, and strategic financial insights."
  }
];

// Testimonials section removed as per client request

export const contactFormFields = {
  name: "",
  company: "",
  email: "",
  phone: "",
  services: []
};

export const serviceOptions = [
  "Accounting & Bookkeeping",
  "VAT & Corporate Tax",
  "ESR & UBO Compliance",
  "Virtual CFO Services",
  "Business Setup Advisory",
  "Audit Support"
];

export const footerData = {
  companyName: "Shine Core Advisory LLC",
  location: "Dubai, United Arab Emirates",
  email: "info@shineaccounting.co",
  phone: "+971 544223506",
  services: [
    "Accounting & Bookkeeping",
    "VAT & Corporate Tax",
    "ESR & UBO Compliance",
    "Virtual CFO Services"
  ],
  socialLinks: {
    linkedin: "https://linkedin.com/company/shine-accounting"
  }
};
